import Vue from 'vue';
import App from './App.vue';
import routerx from './router';
import i18n, { translateError, withLocale } from './i18n';
import './plugins/element.js';
import VueResponsiveProvide from 'vue-provide-responsive';

// Firebase
import firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/remote-config';

Vue.config.productionTip = false;

import '@/assets/linearicons/style.css';

const isDev = process.env.NODE_ENV === 'development';
Vue.prototype.$isDev = isDev;

// Initialize Firebase.
firebase.initializeApp({
	apiKey: process.env.VUE_APP_apiKey,
	authDomain: process.env.VUE_APP_authDomain,
	databaseURL: process.env.VUE_APP_databaseURL,
	projectId: process.env.VUE_APP_projectId,
	storageBucket: process.env.VUE_APP_storageBucket,
	appId: process.env.VUE_APP_appId,
	measurementId: process.env.VUE_APP_measurementId,
});

process.env.NODE_ENV !== 'production' && firebase.functions().useEmulator('localhost', 5001);
// process.env.NODE_ENV !== 'production' && firebase.auth().useEmulator('http://localhost:9099');

Vue.use(require('vue-moment'));

Vue.use(VueResponsiveProvide, {
	breakpoints: {
		mobile: 400,
		// will be converted to responsive.isMobile helper (works exactly like a computed)
		// will be true if the viewport width is less or equals 768 pixels
	},
});

let firestoreSettings: any = {};

// firebase.firestore.setLogLevel('debug')

// firebase.firestore().settings(firestoreSettings);
firebase.firestore();

firebase.auth().languageCode = i18n.locale;

const analytics = firebase.analytics();

Vue.prototype.$firebase = firebase;
Vue.prototype.$analytics = analytics;

// Remote config
const remoteConfig = firebase.remoteConfig();
Vue.prototype.$remoteConfig = remoteConfig;
remoteConfig.settings.minimumFetchIntervalMillis = isDev ? 1000 : 600000;

// `message` accepts either a plain string/key or an Error (e.g. a Firebase
// error), in which case we translate it by its `code`.
const NOTIFICATION_HANDLER = (message: string | any, params?: object) => {
	switch (message) {
		case 'UNSUPPORTED_VERSION':
			Vue.prototype.$message({
				type: 'error',
				message: i18n.t('notifications.unsupportedVersion'),
				...(params || {}),
			});
			break;
		case 'VERIFY_EMAIL':
			Vue.prototype.$message({
				type: 'warning',
				duration: 0,
				closable: true,
				...(params || {}),
			});
			break;
		default:
			Vue.prototype.$message({
				type: 'error',
				message: translateError(message),
				...(params || {}),
			});
			break;
	}
};

Vue.prototype.$NOTIFICATION_HANDLER = NOTIFICATION_HANDLER;

// Carries the active locale over to the other Rambox apps.
Vue.prototype.$withLocale = withLocale;

const router = routerx();

new Vue({
	router,
	i18n,
	render: h => h(App),
}).$mount('#app');
